// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar_toolbar__xy7M0","title":"Toolbar_title__Riv6H","projColor":"Toolbar_projColor__rkgtO","projName":"Toolbar_projName__-IxJS"};